var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3) translate(4.83 4.421)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3A3D43",
    strokeLinecap: "round",
    d: "M7.993 8.142L9.508 6.863"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A3D43",
    d: "M4.31 3.326c1.965 2.387 5.306 6.466 7.525 9.282-1.027.847-2.587 1.456-4.022 1.456-.769 0-1.504-.146-2.178-.413l.067 1.025.001.033c0 .276-.224.5-.5.5H.93c-.098 0-.194-.03-.275-.083-.23-.152-.294-.462-.142-.693l2.179-3.3c-.52-.883-.818-1.911-.818-3.01 0-1.97.96-3.716 2.436-4.797z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.591,
    cy: 6.796,
    r: 1,
    fill: "#3A3D43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    fillRule: "nonzero",
    d: "M11.901 1.424c.911.088 1.735.528 2.327 1.234.592.706.882 1.592.81 2.505-.01.142-.077.256-.176.34-.095.08-.223.128-.364.114-.276-.027-.481-.271-.46-.547.051-.644-.152-1.273-.572-1.773-.42-.5-1-.806-1.644-.868-.275-.027-.483-.275-.462-.55.022-.277.266-.481.541-.455zm-.863 2.12c1.055.105 1.846 1.047 1.763 2.102-.01.141-.08.26-.176.339-.099.083-.223.128-.364.114-.276-.026-.481-.27-.46-.546.02-.248-.057-.487-.217-.677-.16-.19-.381-.308-.625-.328-.279-.03-.484-.275-.462-.55.021-.277.265-.481.54-.454z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDth);
export default __webpack_public_path__ + "static/media/dth.48b23f3956127cf31d3d534b9e96c0e1.svg";
export { ForwardRef as ReactComponent };